import { getApiBaseUrl } from '../config/api';

export async function createHoldRequest(payload) {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    throw new Error('API is not configured.');
  }

  const response = await fetch(`${baseUrl.replace(/\/$/, '')}/holds`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Unable to place a hold. Please try again.');
  }

  return data.hold;
}
